var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGenerate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 50,
    viewBox: "0 0 49 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6395 12.8164V18.8563L32.6926 10.8031L24.6395 2.75V8.78985C20.3678 8.78985 16.2711 10.4868 13.2506 13.5073C10.2301 16.5278 8.5332 20.6245 8.5332 24.8961C8.5332 28.057 9.45931 30.9964 11.0297 33.4727L13.9691 30.5333C13.0399 28.7999 12.5556 26.8629 12.5598 24.8961C12.5598 21.6924 13.8325 18.6199 16.0978 16.3545C18.3632 14.0891 21.4357 12.8164 24.6395 12.8164ZM38.2493 16.3195L35.3099 19.2589C36.1957 20.9501 36.7192 22.8828 36.7192 24.8961C36.7192 28.0999 35.4465 31.1724 33.1811 33.4378C30.9157 35.7032 27.8432 36.9758 24.6395 36.9758V30.936L16.5863 38.9891L24.6395 47.0423V41.0024C28.9111 41.0024 33.0078 39.3055 36.0283 36.285C39.0488 33.2645 40.7458 29.1678 40.7458 24.8961C40.7458 21.7353 39.8196 18.7959 38.2493 16.3195Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenerate);
export default __webpack_public_path__ + "static/media/generate.375b9ae080824d07650ad8e87937d887.svg";
export { ForwardRef as ReactComponent };